import { Form, Formik } from "formik";
import Button from "../UI/Button";
import { useState } from "react";
import Callout from "./Callout";
import { handleAPIError } from "../../utils/index.jsx";
import FormikSubmitButton from "./FormikSubmitButton";
import { ModalDialogFooter } from "./ModalDialog";

function PartForm({
  partForm,
  deleteHandler,
  archiveHandler,
  reactivateHandler,
  validationSchema,
  initialValues,
  submitHandler,
  closeModal,
}) {
  const [error, setError] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  async function submit(values, { setSubmitting }) {
    try {
      await submitHandler(values);
      closeModal();
      setError("");
    } catch (error) {
      setError(handleAPIError(error));
    }
    setSubmitting(false);
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={submit}
      validationSchema={validationSchema}
    >
      {() => {
        return (
          <Form>
            {partForm}
            <Callout variant="danger">{error}</Callout>
            <ModalDialogFooter>
              {deleteHandler && (
                <Button
                  type="button"
                  variant="secondary"
                  isLoading={isDeleting}
                  requiresWrite
                  onClick={async () => {
                    setIsDeleting(true);
                    await deleteHandler();
                    setIsDeleting(false);
                  }}
                >
                  Supprimer
                </Button>
              )}
              {archiveHandler && (
                <Button
                  type="button"
                  variant="secondary"
                  requiresWrite
                  onClick={archiveHandler}
                >
                  Archiver
                </Button>
              )}
              {reactivateHandler && (
                <Button
                  type="button"
                  variant="secondary"
                  requiresWrite
                  onClick={reactivateHandler}
                >
                  Réactiver
                </Button>
              )}
              <FormikSubmitButton requiresWrite>Valider</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        );
      }}
    </Formik>
  );
}

export default PartForm;
